import User from '../interfaces/User';

export const PERMISSIONS = {
  MANAGE_AGENTS: 'manage_agents',
  MANAGE_KNOWLEDGE: 'manage_knowledge',
  VIEW_AGENTS_DASHBOARD: 'view_agents_dashboard',
  MANAGE_BILLING: 'manage_billing',
  MANAGE_USERS: 'manage_users',
  MANAGE_INTEGRATIONS: 'manage_integrations',
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

export function canPerformAction(user: User, permission: Permission): boolean {
  return Boolean(user.permissions?.[permission]);
}
